import Card from 'react-bootstrap/Card';
import { Form as BSForm, Row, Col } from 'react-bootstrap';

import { Formik, FieldArray } from 'formik';
import { OverallWorkExperienceForm } from './overallWorkExperienceFragment';
import { CurrentRoleForm } from './currentRoleFragment';
import { ReportingStructureForm } from './reportingStructureFragment';
import { PromotionsForm } from './promotionsFragment';
import { PreviousJobForm } from './previousJobsFragment';
import LinkButton from '../../../../ui-elements/signite-link-button/linkButton';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { PreviousJobReportingStructureForm } from './previousJobReportingStructureFragment';
import JSONPretty from 'react-json-pretty';
import { PreviousJobPromotionsForm } from './previousJobsPromotions';
import { AwardsForm } from './awardsFormFragment';
import SigniteToggle from '../../../../ui-elements/toggle-switch/signiteToggleSwitch';
import { CareerGapForm } from './careerGapFragment';
import { TechnicalProficiencyForm } from './technicalProficiencyFragment';
import { ProfessionalMembershipForm } from './professionalMembershipFragment';
import { WorkExperienceSchema } from '../../validations/workExperienceValidationSchema';
import { reverseTransformWorkExperienceDetails } from '../../transformers/workExperienceTransformer';
import { useEffect, useState } from 'react';
import { MasterDataService } from '../../../../../services/masterDataService';

const CandidateWorkExperienceForm = ({ componentRef, onSubmit, workExperience, saveCurrentValues }) => {
  const [cities, setCities] = useState([]);
  const [industrySectors, setIndustrySectors] = useState([]);
  const [functions, setFunctions] = useState([]);

  useEffect(() => {
    MasterDataService.getAllCities()
      .then((res) => setCities(res.data || []))
      .catch((err) => console.error('Failed to load cities:', err));

    MasterDataService.getAllIndustrySectors()
      .then((res) => setIndustrySectors(res.data || []))
      .catch((err) => console.error('Failed to load industries:', err));

    MasterDataService.getAllFunctions()
      .then((res) => setFunctions(res.data || []))
      .catch((err) => console.error('Failed to load functions:', err));

  }, []);

  const initialValues = {
    careerPromotions: [],
    previousJobs: [],
    currentOrganizationName: '',
    currentOrganizationId: '',
    currentIndustrySector: '',
    currentIndustrySubCategory: '',
    currentFunction: "",
    currentFunctionSubCategory: "",

    currentRoleStartDate: '',
    currentNoticePeriod: '',
    currentDesignation: '',
    currenttop3Responsibilities: '',
    currenttop3Achievements: '',
    currentReportingTo: '',
    currentNumberOfReportees: null,
    currentTeamSize: null,
    careerGaps: [],
    awards: [],
    professionalMemberships: [],
  };

  let workExperienceData = workExperience && reverseTransformWorkExperienceDetails(workExperience.workExperience);

  if (workExperienceData) {
    workExperienceData.currenttop3Achievements = Array.isArray(workExperienceData.currenttop3Achievements)
      ? workExperienceData.currenttop3Achievements.join(', ')
      : workExperienceData.currenttop3Achievements ?? '';
    if (Array.isArray(workExperienceData.previousJobs)) {
      workExperienceData.previousJobs = workExperienceData.previousJobs.map((job) => ({
        ...job,
        top3Achievements: Array.isArray(job.top3Achievements)
          ? job.top3Achievements.join(', ')
          : job.top3Achievements ?? '',
      }));
    }
  }
  const moveCurrentRoleToPrevious = (values, setFieldValue) => {
    const currentJob = {
      designation: values.currentDesignation || '',
      organizationName: values.currentOrganizationName || '',
      clientId: values.currentOrganizationId || null,
      industrySector: values.currentIndustrySector || '',
      subcategory: values.currentIndustrySubCategory || '',
      function: values.currentFunction || '',
      functionSubcategory: values.currentFunctionSubCategory || '',
      location: values.currentLocation || '',
      roleStartDate: values.currentRoleStartDate || '',
      roleEndDate: null,
      noticePeriod: values.currentNoticePeriod || '',
      top3Responsibilities: values.currenttop3Responsibilities || '',
      top3Achievements: values.currenttop3Achievements || '',
      reportingTo: values.currentReportingTo || '',
      numberOfReportees: values.currentNumberOfReportees || 0,
      teamSize: values.currentTeamSize || 0,
      hasGotPromotions: values.hasGotPromotions,
      careerPromotions: values.careerPromotions || [],
    };

    const updatedPreviousJobs = [currentJob, ...(values.previousJobs || [])];

    setFieldValue('currentDesignation', '');
    setFieldValue('currentOrganizationName', '');
    setFieldValue('currentOrganizationId', '');
    setFieldValue('currentIndustrySector', '');
    setFieldValue('currentIndustrySubCategory', '');
    setFieldValue('currentFunction', '');
    setFieldValue('currentFunctionSubCategory', '');

    setFieldValue('currentLocation', '');
    setFieldValue('currentRoleStartDate', '');
    setFieldValue('currentNoticePeriod', '');
    setFieldValue('currenttop3Responsibilities', '');
    setFieldValue('currenttop3Achievements', '');
    setFieldValue('currentReportingTo', '');
    setFieldValue('currentNumberOfReportees', '');
    setFieldValue('currentTeamSize', '');

    setFieldValue('hasGotPromotions', false);
    setFieldValue('careerPromotions', []);
    setFieldValue('previousJobs', updatedPreviousJobs);
  };

  return (
    <Formik
      enableReinitialize="true"
      initialValues={workExperienceData || initialValues}
      onSubmit={async (data) => {
        if (Array.isArray(data.currenttop3Achievements)) {
          data.currenttop3Achievements = data.currenttop3Achievements.join(', ');
        } else if (data.currenttop3Achievements === undefined || data.currenttop3Achievements === null) {
          data.currenttop3Achievements = '';
        }
        if (Array.isArray(data.previousJobs)) {
          data.previousJobs = data.previousJobs.map((job) => ({
            ...job,
            top3Achievements: Array.isArray(job.top3Achievements)
              ? job.top3Achievements.join(', ')
              : job.top3Achievements ?? '',
          }));
        }
        onSubmit(data, 'work-experience');
      }}
      validationSchema={WorkExperienceSchema}
      innerRef={componentRef}
      isInitialValid={true}
    >
      {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => {
        saveCurrentValues(values);
        return (
          <>
            {window.debug && window.debug == true && (
              <Card className="mb-3">
                <Card.Title>DEBUG</Card.Title>
                <Card.Body className="side-pad-24">
                  <JSONPretty data={values}></JSONPretty>
                  <JSONPretty data={errors}></JSONPretty>
                  <JSONPretty data={touched}></JSONPretty>
                </Card.Body>
              </Card>
            )}
            <Card>
              <Card.Title>Work Experience</Card.Title>
              <Card.Body className="side-pad-24">
                <OverallWorkExperienceForm
                  handleChange={handleChange}
                  values={values}
                  errors={errors}
                  handleBlur={handleBlur}
                  touched={touched}
                ></OverallWorkExperienceForm>
                <hr style={{ marginTop: 32, marginBottom: 32 }} />
              </Card.Body>


              <Card.Body className="side-pad-24">
                <CurrentRoleForm
                  handleChange={handleChange}
                  values={values}
                  cities={cities}
                  industrySectors={industrySectors}
                  functions={functions}
                  errors={errors}
                  handleBlur={handleBlur}
                  touched={touched}
                  initialized={workExperienceData != null}
                  moveCurrentRoleToPrevious={moveCurrentRoleToPrevious}

                ></CurrentRoleForm>
                <hr style={{ marginTop: 32, marginBottom: 32 }} />
              </Card.Body>
              <Card.Title className="pt-0">Reporting Structure</Card.Title>
              <Card.Body className="side-pad-24">
                <ReportingStructureForm
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  touched={touched}
                  values={values}
                  errors={errors}
                  initialized={workExperienceData != null}
                ></ReportingStructureForm>
                <hr style={{ marginTop: 32, marginBottom: 32 }} />
              </Card.Body>
              <Card.Title className="pt-0">Promotions</Card.Title>
              <Card.Body className="side-pad-24">
                <PromotionsForm
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  touched={touched}
                  values={values}
                  errors={errors}
                  initialized={workExperienceData != null}
                ></PromotionsForm>
              </Card.Body>
            </Card>

            <FieldArray name="previousJobs">
              {({ remove, push }) => (
                <>
                  {values.previousJobs &&
                    values.previousJobs.length > 0 &&
                    values.previousJobs.map((job, index) => (
                      <Card
                        style={{
                          paddingBottom: 20,
                          marginTop: 24,
                          marginBottom: 20,
                        }}
                        key={`card-${index}`}
                      >
                        <Card.Title>Previous Job {index + 1}</Card.Title>
                        <Card.Body className="side-pad-24">
                          <PreviousJobForm
                            handleChange={handleChange}
                            values={values}
                            job={job}
                            cities={cities}
                            index={index}
                            errors={errors}
                            handleBlur={handleBlur}
                            touched={touched}
                            industrySectors={industrySectors}
                            functions={functions}

                            setFieldValue={setFieldValue}
                          />
                          <hr
                            style={{
                              marginTop: 32,
                              marginBottom: 32,
                            }}
                          />
                          <PreviousJobReportingStructureForm
                            handleChange={handleChange}
                            values={values}
                            job={job}
                            index={index}
                            errors={errors}
                            handleBlur={handleBlur}
                            touched={touched}
                          />
                          <hr
                            style={{
                              marginTop: 32,
                              marginBottom: 32,
                            }}
                          />
                          <PreviousJobPromotionsForm
                            handleChange={handleChange}
                            values={values}
                            job={job}
                            index={index}
                            errors={errors}
                            handleBlur={handleBlur}
                            touched={touched}
                          />
                        </Card.Body>
                        <Row>
                          <Col className="d-flex justify-content-center">
                            <LinkButton
                              label="Remove This Job"
                              onClick={() => remove(index)}
                              icon={faMinusCircle}
                            ></LinkButton>
                          </Col>
                        </Row>
                      </Card>
                    ))}
                  <Card
                    style={{
                      paddingBottom: 20,
                      marginTop: 24,
                      marginBottom: 20,
                    }}
                  >
                    <Card.Body className="side-pad-24">
                      <Row>
                        <Col>
                          <LinkButton
                            label="Add Previous Job"
                            onClick={() =>
                              push({
                                top3Achievements: '',
                                top3Responsibilities: '',
                                location: '',
                                roleStartDate: '',
                                noticePeriod: '',
                                industrySector: '',
                                subcategory: '',
                                function: "",
                                functionSubcategory: "",
                                organizationName: '',
                                designation: '',
                                hasGotPromotions: false,
                              })
                            }
                          ></LinkButton>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </>
              )}
            </FieldArray>

            <Card
              style={{
                paddingBottom: 20,
                marginTop: 24,
                marginBottom: 20,
              }}
            >
              <Card.Title>Awards</Card.Title>
              <FieldArray name="awards">
                {({ remove, push }) => (
                  <>
                    {values.awards &&
                      values.awards.length > 0 &&
                      values.awards.map((award, index) => (
                        <>
                          <Card.Title>Award {index + 1}</Card.Title>
                          <Card.Body className="side-pad-24">
                            <AwardsForm
                              values={values}
                              handleChange={handleChange}
                              award={award}
                              index={index}
                              errors={errors}
                              handleBlur={handleBlur}
                              touched={touched}
                            />
                          </Card.Body>
                          <Row>
                            <Col className="d-flex justify-content-center">
                              <LinkButton
                                label="Remove This Award"
                                onClick={() => remove(index)}
                                icon={faMinusCircle}
                              ></LinkButton>
                            </Col>
                          </Row>
                          <hr
                            style={{
                              marginTop: 32,
                              marginBottom: 32,
                            }}
                          />
                        </>
                      ))}

                    <Card.Body className="side-pad-24">
                      <Row>
                        <Col>
                          <LinkButton
                            label="Add Award"
                            onClick={() =>
                              push({
                                title: '',
                                providedBy: '',
                                issueDate: '',
                              })
                            }
                          ></LinkButton>
                        </Col>
                      </Row>
                    </Card.Body>
                  </>
                )}
              </FieldArray>
            </Card>
            <Card
              style={{
                paddingBottom: 20,
                marginTop: 24,
                marginBottom: 20,
              }}
            >
              <Card.Title>Career Gaps</Card.Title>
              <Card.Body className="side-pad-24">
                <Row>
                  <BSForm.Group as={Col} controlId="hasCareerGaps">
                    <BSForm.Label>Do you have any Career Gaps?</BSForm.Label>
                    <SigniteToggle
                      id={'hasCareerGaps'}
                      dataYes={'Yes'}
                      dataNo={'No'}
                      fieldInput={{
                        onChange: handleChange,
                        value: values.hasCareerGaps,
                      }}
                    />
                  </BSForm.Group>
                </Row>
                {values.hasCareerGaps && (
                  <CareerGapForm
                    values={values}
                    handleChange={handleChange}
                    errors={errors}
                    handleBlur={handleBlur}
                    touched={touched}
                  ></CareerGapForm>
                )}
              </Card.Body>
            </Card>
            <Card
              style={{
                paddingBottom: 20,
                marginTop: 24,
                marginBottom: 20,
              }}
            >
              <Card.Title>Technical Proficiency</Card.Title>
              <Card.Body className="side-pad-24">
                <TechnicalProficiencyForm
                  values={values}
                  handleChange={handleChange}
                  errors={errors}
                  handleBlur={handleBlur}
                  touched={touched}
                />
              </Card.Body>
            </Card>
            <Card
              style={{
                paddingBottom: 20,
                marginTop: 24,
                marginBottom: 20,
              }}
            >
              <Card.Title>Professional Membership</Card.Title>
              <Card.Body className="side-pad-24">
                <ProfessionalMembershipForm
                  values={values}
                  handleChange={handleChange}
                  errors={errors}
                  handleBlur={handleBlur}
                  touched={touched}
                />
              </Card.Body>
            </Card>
          </>
        );
      }}
    </Formik>
  );
};

export default CandidateWorkExperienceForm;
